/* eslint-disable jsx-a11y/heading-has-content */
import React from 'react'
import '../style/result.css'
import CaseSudyCard from './CaseSudyCard'

const Result = () => {
  return (
    <>
      <section id='caseStudy'>
        <div className="container" style={{ textAlign: 'center' }}>
          <h4 id='animath5' style={{ color: "white", paddingTop: "125px", paddingBottom: '175px' }}></h4>
        </div>
      </section>
      {/* <div className='container'>
        <div className='row' style={{ marginTop: '50px' }}>
          <div className='col-sm' style={{padding: '15px' }}>
            <div className='inside' style={{ boxShadow: '2px 2px 5px 5px lightgray', borderRadius: '10px' }}>
              <div style={{ backgroundColor: '#F3F3F3', marginTop:'25px' }}>
                <div className='row' style={{ marginTop: '40px', marginLeft: '15px' }}>
                  <div className='col-4' style={{ textAlign: 'center' }}>
                    <img style={{ borderRadius: "80px", marginTop: '30px' }} src="https://i.pinimg.com/originals/d5/b0/4c/d5b04cc3dcd8c17702549ebc5f1acf1a.png" width={'70px'} height={'70px'} alt="clinetPhoto" />
                  </div>
                  <div className='col-8' style={{marginTop:"20px"}}>
                    <h5>SAJIT SHANKAR</h5>
                    <h6>Industrial Water Treatment Chemicals</h6>
                    <p style={{ fontSize: '15px' }}>THERMOCHEM CORPORATION PVT</p>
                  </div>
                </div>
                <hr />
              </div>
              <div style={{ marginTop: '10px', textAlign: 'center', paddingBottom:'15px' }}>
                <h5>Aunnal  Avg. before Coaching : - Rs 15 Crore</h5>
                <h5 >Aunnal  Avg. after Coaching :- Rs 20 Crore</h5>
              </div>
            </div>
          </div>
          <div className='col-sm' style={{padding: '15px' }}>
            <div className='inside' style={{ boxShadow: '2px 2px 5px 5px lightgray', borderRadius: '10px' }}>
              <div style={{ backgroundColor: '#F3F3F3', marginTop:'25px' }}>
                <div className='row' style={{ marginTop: '40px', marginLeft: '15px' }}>
                  <div className='col-4' style={{ textAlign: 'center' }}>
                    <img style={{ borderRadius: "80px", marginTop: '30px' }} src="https://i.pinimg.com/originals/d5/b0/4c/d5b04cc3dcd8c17702549ebc5f1acf1a.png" width={'70px'} height={'70px'} alt="clinetPhoto" />
                  </div>
                  <div className='col-8' style={{marginTop:"20px"}}>
                    <h5>Mr. Tapas Maiti's</h5>
                    <h6>Providing Accounting, Audit, Tax, and ROC Services</h6>
                    <p style={{ fontSize: '15px' }}>Practising CA (FCA)</p>
                  </div>
                </div>
                <hr />
              </div>
              <div style={{ marginTop: '10px', textAlign: 'center', paddingBottom:'15px' }}>
                <h5>Aunnal Avg. before Coaching : - Rs 35 lakhs</h5>
                <h5 >Aunnal Avg. after Coaching :- Rs 50 lakhs</h5>
              </div>
            </div>
          </div>
          <div className='col-sm' style={{padding: '15px' }}>
            <div className='inside' style={{ boxShadow: '2px 2px 5px 5px lightgray', borderRadius: '10px' }}>
              <div style={{ backgroundColor: '#F3F3F3', marginTop:'25px' }}>
                <div className='row' style={{ marginTop: '40px', marginLeft: '15px' }}>
                  <div className='col-4' style={{ textAlign: 'center' }}>
                    <img style={{ borderRadius: "80px", marginTop: '30px' }} src="https://i.pinimg.com/originals/d5/b0/4c/d5b04cc3dcd8c17702549ebc5f1acf1a.png" width={'70px'} height={'70px'} alt="clinetPhoto" />
                  </div>
                  <div className='col-8' style={{marginTop:"20px"}}>
                    <h5>Mr Shishir Khedkar</h5>
                    <h6>Services - Software development service</h6>
                    <p style={{ fontSize: '15px' }}>Splashjet Inkjet Ink Pvt.</p>
                  </div>
                </div>
                <hr />
              </div>
              <div style={{ marginTop: '10px', textAlign: 'center', paddingBottom:'15px' }}>
                <h5>Aunnal Avg. before Coaching : - Rs 10 crores</h5>
                <h5 >Aunnal Avg. after Coaching :- Rs 18.3 crores</h5>
              </div>
            </div>
          </div>
        </div>
        <div className='row' >
          <div className='col-sm' style={{padding: '15px' }}>
            <div className='inside' style={{ boxShadow: '2px 2px 5px 5px lightgray', borderRadius: '10px' }}>
              <div style={{ backgroundColor: '#F3F3F3', marginTop:'25px' }}>
                <div className='row' style={{ marginTop: '40px', marginLeft: '15px' }}>
                  <div className='col-4' style={{ textAlign: 'center' }}>
                    <img style={{ borderRadius: "80px", marginTop: '30px' }} src="https://i.pinimg.com/originals/d5/b0/4c/d5b04cc3dcd8c17702549ebc5f1acf1a.png" width={'70px'} height={'70px'} alt="clinetPhoto" />
                  </div>
                  <div className='col-8' style={{marginTop:"20px"}}>
                    <h5>Mr. Sudhakar Ponnuru</h5>
                    <h6>Offering Certification Products, Audits, and Training</h6>
                    <p style={{ fontSize: '15px' }}>Smartedge Consulting</p>
                  </div>
                </div>
                <hr />
              </div>
              <div style={{ marginTop: '10px', textAlign: 'center', paddingBottom:'15px' }}>
                <h5>Aunnal Avg. before Coaching : - Rs 70 Lakhs</h5>
                <h5 >Aunnal Avg. after Coaching :- Rs 1.06 Crore</h5>
              </div>
            </div>
          </div>
          <div className='col-sm' style={{padding: '15px' }}>
            <div className='inside' style={{ boxShadow: '2px 2px 5px 5px lightgray', borderRadius: '10px' }}>
              <div style={{ backgroundColor: '#F3F3F3', marginTop:'25px' }}>
                <div className='row' style={{ marginTop: '40px', marginLeft: '15px' }}>
                  <div className='col-4' style={{ textAlign: 'center' }}>
                    <img style={{ borderRadius: "80px", marginTop: '30px' }} src="https://i.pinimg.com/originals/d5/b0/4c/d5b04cc3dcd8c17702549ebc5f1acf1a.png" width={'70px'} height={'70px'} alt="clinetPhoto" />
                  </div>
                  <div className='col-8' style={{marginTop:"20px"}}>
                    <h5>Mr. Amitdas</h5>
                    <h6>NGO dedicated to spreading spirituality</h6>
                    <p style={{ fontSize: '15px' }}>Head of Hare Krishna Mission</p>
                  </div>
                </div>
                <hr />
              </div>
              <div style={{ marginTop: '10px', textAlign: 'center', paddingBottom:'15px' }}>
                <h5>Aunnal Avg. before Coaching : - Rs 1 Crore</h5>
                <h5 >Aunnal Avg. after Coaching :- Rs 20 Crore</h5>
              </div>
            </div>
          </div>
          <div className='col-sm' style={{padding: '15px' }}>
            <div className='inside' style={{ boxShadow: '2px 2px 5px 5px lightgray', borderRadius: '10px' }}>
              <div style={{ backgroundColor: '#F3F3F3', marginTop:'25px' }}>
                <div className='row' style={{ marginTop: '40px', marginLeft: '15px' }}>
                  <div className='col-4' style={{ textAlign: 'center' }}>
                    <img style={{ borderRadius: "80px", marginTop: '30px' }} src="https://i.pinimg.com/originals/d5/b0/4c/d5b04cc3dcd8c17702549ebc5f1acf1a.png" width={'70px'} height={'70px'} alt="clinetPhoto" />
                  </div>
                  <div className='col-8' style={{marginTop:"20px"}}>
                    <h5>Mr. Saurabh Jain</h5>
                    <h6>Plastic Processing Machinery and Maintenance Services</h6>
                    <p style={{ fontSize: '15px' }}>V.K. Engineering Works</p>
                  </div>
                </div>
                <hr />
              </div>
              <div style={{ marginTop: '10px', textAlign: 'center', paddingBottom:'15px' }}>
                <h5>Aunnal Avg. before Coaching : - Rs 1.53 Crore</h5>
                <h5 >Aunnal Avg. after Coaching :- Rs 2.5 Crore</h5>
              </div>
            </div>
          </div>
        </div>
        <div className='row' style={{ marginTop: '50px' }}>
          <div className='col-sm' style={{padding: '15px' }}>
            <div className='inside' style={{ boxShadow: '2px 2px 5px 5px lightgray', borderRadius: '10px' }}>
              <div style={{ backgroundColor: '#F3F3F3', marginTop:'25px' }}>
                <div className='row' style={{ marginTop: '40px', marginLeft: '15px' }}>
                  <div className='col-4' style={{ textAlign: 'center' }}>
                    <img style={{ borderRadius: "80px", marginTop: '30px' }} src="https://i.pinimg.com/originals/d5/b0/4c/d5b04cc3dcd8c17702549ebc5f1acf1a.png" width={'70px'} height={'70px'} alt="clinetPhoto" />
                  </div>
                  <div className='col-8' style={{marginTop:"20px"}}>
                    <h5>Mr. Yogesh Panchal </h5>
                    <h6>Automatic Rolling Shutters and Sliding Doors</h6>
                    <p style={{ fontSize: '15px' }}>Panchal Industries</p>
                  </div>
                </div>
                <hr />
              </div>
              <div style={{ marginTop: '10px', textAlign: 'center', paddingBottom:'15px' }}>
                <h5>Aunnal Avg. before Coaching : - Rs 4 Crore</h5>
                <h5 >Aunnal Avg. after Coaching :- Rs 12 crore</h5>
              </div>
            </div>
          </div>
          <div className='col-sm' style={{padding: '15px' }}>
            <div className='inside' style={{ boxShadow: '2px 2px 5px 5px lightgray', borderRadius: '10px' }}>
              <div style={{ backgroundColor: '#F3F3F3', marginTop:'25px' }}>
                <div className='row' style={{ marginTop: '40px', marginLeft: '15px' }}>
                  <div className='col-4' style={{ textAlign: 'center' }}>
                    <img style={{ borderRadius: "80px", marginTop: '30px' }} src="https://i.pinimg.com/originals/d5/b0/4c/d5b04cc3dcd8c17702549ebc5f1acf1a.png" width={'70px'} height={'70px'} alt="clinetPhoto" />
                  </div>
                  <div className='col-8' style={{marginTop:"20px"}}>
                    <h5>Jonathan Gola</h5>
                    <h6>Design, Manufacture, Install and Maintain all types of elevators</h6>
                    <p style={{ fontSize: '15px' }}>JR ONE LIFTS PVT</p>
                  </div>
                </div>
                <hr />
              </div>
              <div style={{ marginTop: '10px', textAlign: 'center', paddingBottom:'15px' }}>
                <h5>Aunnal Avg. before Coaching : - Rs 6 Crore</h5>
                <h5 >Aunnal Avg. after Coaching :- Rs 10 Crore</h5>
              </div>
            </div>
          </div>
          <div className='col-sm' style={{padding: '15px' }}>
            <div className='inside' style={{ boxShadow: '2px 2px 5px 5px lightgray', borderRadius: '10px' }}>
              <div style={{ backgroundColor: '#F3F3F3', marginTop:'25px' }}>
                <div className='row' style={{ marginTop: '40px', marginLeft: '15px' }}>
                  <div className='col-4' style={{ textAlign: 'center' }}>
                    <img style={{ borderRadius: "80px", marginTop: '30px' }} src="https://i.pinimg.com/originals/d5/b0/4c/d5b04cc3dcd8c17702549ebc5f1acf1a.png" width={'70px'} height={'70px'} alt="clinetPhoto" />
                  </div>
                  <div className='col-8' style={{marginTop:"20px"}}>
                    <h5>Naresh Gupta</h5>
                    <h6>A retail and wholesale distributor of cleaning products.</h6>
                    <p style={{ fontSize: '15px' }}>SAI CHEMICALS and Naresh Chemical</p>
                  </div>
                </div>
                <hr />
              </div>
              <div style={{ marginTop: '10px', textAlign: 'center', paddingBottom:'15px' }}>
                <h5>Aunnal Avg. before Coaching : - Rs 6 Crore</h5>
                <h5 >Aunnal Avg. after Coaching :- Rs 12 Crore</h5>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <CaseSudyCard/>
    </>
  )
}

export default Result
